import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "items"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React from 'react';
import createNavItem from '../factories/createNavItem';
var rootStyles = process.env.NODE_ENV === "production" ? {
  name: "1rqmqnu",
  styles: "display:block;margin:0;padding:0;& li{padding:8px 0 0;}"
} : {
  name: "1pcjmg0-rootStyles",
  styles: "display:block;margin:0;padding:0;& li{padding:8px 0 0;};label:rootStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL05hdkxpc3QudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW1CbUIiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvTmF2TGlzdC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cblxuaW1wb3J0IHsgY3NzLCBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IGNyZWF0ZU5hdkl0ZW0gZnJvbSAnLi4vZmFjdG9yaWVzL2NyZWF0ZU5hdkl0ZW0nO1xuaW1wb3J0IHR5cGUgeyBOYXZJdGVtU2hvcnRoYW5kIH0gZnJvbSAnLi4vdHlwZXMnO1xuXG50eXBlIE93blByb3BzID0ge1xuICBjaGlsZHJlbj86IFJlYWN0LlJlYWN0Tm9kZTtcbiAgaXRlbXM/OiBOYXZJdGVtU2hvcnRoYW5kW107XG59O1xuXG50eXBlIFVuaGFuZGxlZFByb3BzID0gT21pdDxcbiAgUmVhY3QuSFRNTEF0dHJpYnV0ZXM8SFRNTFVMaXN0RWxlbWVudD4sXG4gIGtleW9mIE93blByb3BzXG4+O1xuXG50eXBlIFByb3BzID0gT3duUHJvcHMgJiBVbmhhbmRsZWRQcm9wcztcblxuY29uc3Qgcm9vdFN0eWxlcyA9IGNzcyh7XG4gIGRpc3BsYXk6ICdibG9jaycsXG4gIG1hcmdpbjogJzAnLFxuICBwYWRkaW5nOiAnMCcsXG4gICcmIGxpJzoge1xuICAgIHBhZGRpbmc6ICc4cHggMCAwJyxcbiAgfSxcbn0pO1xuXG5jb25zdCBOYXZMaXN0OiBSZWFjdC5GQzxQcm9wcz4gPSAoe1xuICBjaGlsZHJlbixcbiAgaXRlbXMgPSBbXSxcbiAgLi4udW5oYW5kbGVkUHJvcHNcbn0pID0+IChcbiAgPHVsIHsuLi51bmhhbmRsZWRQcm9wc30gY3NzPXtyb290U3R5bGVzfT5cbiAgICB7Y2hpbGRyZW4gIT0gbnVsbCA/IGNoaWxkcmVuIDogaXRlbXMubWFwKChpdGVtKSA9PiBjcmVhdGVOYXZJdGVtKGl0ZW0pKX1cbiAgPC91bD5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IE5hdkxpc3Q7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var NavList = function NavList(_ref) {
  var children = _ref.children,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return jsx("ul", _extends({}, unhandledProps, {
    css: rootStyles
  }), children != null ? children : items.map(function (item) {
    return createNavItem(item);
  }));
};

export default NavList;